import { SVGProps } from 'react';

const WordPress = ({ props }: { props?: SVGProps<SVGSVGElement>; size?: string | number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="73" height="73" viewBox="0 0 73 73" fill="none" {...props}>
    <path
      fill="#fff"
      d="M5.145 36.206c0 12.295 7.144 22.92 17.505 27.954L7.834 23.565a30.943 30.943 0 0 0-2.69 12.641ZM57.176 34.639c0-3.84-1.379-6.498-2.562-8.567-1.574-2.558-3.05-4.725-3.05-7.284 0-2.855 2.166-5.513 5.216-5.513.138 0 .268.018.402.025a30.946 30.946 0 0 0-20.974-8.154c-10.851 0-20.398 5.568-25.952 14 .729.023 1.415.038 1.999.038 3.248 0 8.277-.394 8.277-.394 1.675-.1 1.872 2.36.2 2.558 0 0-1.683.198-3.555.296l11.31 33.644 6.798-20.386-4.84-13.259c-1.672-.098-3.256-.296-3.256-.296-1.674-.098-1.478-2.657.196-2.559 0 0 5.13.395 8.181.395 3.249 0 8.278-.395 8.278-.395 1.676-.098 1.873 2.361.2 2.559 0 0-1.687.198-3.556.296l11.225 33.39 3.098-10.354c1.343-4.296 2.365-7.382 2.365-10.04Z"
    />
    <path
      fill="#fff"
      d="m36.753 38.923-9.32 27.08a31.058 31.058 0 0 0 19.09-.495 2.725 2.725 0 0 1-.222-.428l-9.548-26.157ZM63.462 21.304c.134.99.21 2.051.21 3.194 0 3.151-.589 6.695-2.362 11.125l-9.488 27.431c9.234-5.385 15.445-15.389 15.445-26.848.001-5.4-1.378-10.478-3.805-14.902Z"
    />
    <path
      fill="#fff"
      d="M36.207 0C16.243 0 0 16.242 0 36.206c0 19.966 16.243 36.208 36.207 36.208 19.964 0 36.21-16.242 36.21-36.208C72.414 16.242 56.17 0 36.206 0Zm0 70.754c-19.049 0-34.547-15.498-34.547-34.548C1.66 17.157 17.158 1.66 36.207 1.66c19.048 0 34.545 15.497 34.545 34.546 0 19.05-15.497 34.548-34.545 34.548Z"
    />
  </svg>
);

export default WordPress;
